export default "__VITE_ASSET__3e9313c7__"